import { SimpleGrid, Stack } from "@chakra-ui/react";
import FinancialMetric from "../../../../components/FinancialMetric";
import { SectionWrapper } from "../SectionWrapper";
import type { HTMLAttributes } from "react";
import React from "react";

// Financial Data will use ticker in real implementation
interface FinancialSummaryData {
  grossProfitMargin?: string;
  quickRatio?: number;
  operatingCashFlowMargin?: string;
  operatingMargin?: string;
  returnOnAssets?: string;
  freeCashFlow?: string;
  netProfitMargin?: string;
  returnOnEquity?: string;
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  financialSummaryData: FinancialSummaryData;
}

function SectionFinancialSummary({ financialSummaryData, ...props }: Props) {
  return (
    <SectionWrapper title="Financial Summary Q2 2025 (CAD)" {...props}>
      <SimpleGrid columns={3} spacing="1.5rem" p="1rem">
        <Stack spacing="1rem">
          <FinancialMetric title="Gross Profit Margin" value={financialSummaryData.grossProfitMargin} />
          <FinancialMetric title="Quick Ratio/Acid Test" value={financialSummaryData.quickRatio} />
          <FinancialMetric title="Operating Cash Flow Margin" value={financialSummaryData.operatingCashFlowMargin} />
        </Stack>

        <Stack spacing="1rem">
          <FinancialMetric title="Operating Margin" value={financialSummaryData.operatingMargin} />
          <FinancialMetric title="Return on Assets" value={financialSummaryData.returnOnAssets} />
          <FinancialMetric title="Free Cash Flow" value={financialSummaryData.freeCashFlow} />
        </Stack>

        <Stack spacing="1rem">
          <FinancialMetric title="Net Profit Margin" value={financialSummaryData.netProfitMargin} />
          <FinancialMetric title="Return on Equity" value={financialSummaryData.returnOnEquity} />
        </Stack>
      </SimpleGrid>
    </SectionWrapper>
  );
}

export default React.memo(SectionFinancialSummary);
